import { getOrderWithStock } from '../../../redux-api-bridge/order/selectors'
import {
  getCurrentTimeslot,
  getDefaultAddress,
  getUserPlanSelector
} from '../../../redux-api-bridge/selectors'
import { getUpcomingDeliveries } from '../../../modules/MyDeliveries/selectors'
import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { getTimeslot } from '../../../utils/utils'

const getCombinedData = createSelector(
  [
    getOrderWithStock,
    getUpcomingDeliveries,
    getUserPlanSelector,
    getDefaultAddress,
    getCurrentTimeslot
  ],
  (
    productsWithStock,
    upcomingDeliveries,
    plan,
    defaultAddress,
    defaultTimeslot
  ) => ({
    productsWithStock,
    upcomingDeliveries,
    plan,
    defaultAddress,
    defaultTimeslot
  })
)

const useCheckoutData = (date: string) => {
  const {
    upcomingDeliveries,
    defaultTimeslot,
    defaultAddress,
    ...rest
  } = useSelector(getCombinedData)

  const { selectedUpcomingDay, deliveryIndex } = useMemo(() => {
    const index = upcomingDeliveries.findIndex(day => day.date === date)
    return {
      selectedUpcomingDay: index !== -1 ? upcomingDeliveries[index] : null,
      deliveryIndex: index
    }
  }, [upcomingDeliveries, date])

  const timeSlot = useMemo(() => {
    return selectedUpcomingDay?.order
      ? getTimeslot({
          start: selectedUpcomingDay.order.time_start,
          end: selectedUpcomingDay.order.time_end
        })
      : defaultTimeslot
  }, [selectedUpcomingDay?.order, defaultTimeslot])

  const address = selectedUpcomingDay?.order?.address ?? defaultAddress
  const deliveryAddress = `${address?.street}, ${address.city}, ${address.region}`

  return {
    ...rest,
    selectedUpcomingDay,
    deliveryIndex,
    timeSlot,
    deliveryAddress
  }
}

export default useCheckoutData
